import React from 'react';
import { Link } from 'react-scroll';

const Hero = () => {
  return (
    <section id="hero" className="min-h-screen flex items-center bg-gradient-to-br from-cream to-white pt-20">
      <div className="section-container">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="order-2 md:order-1">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 text-balance">
              Hey, I'm <span className="inline-block animate-wave">👋</span>{' '}
              <span className="gradient-text">Neel Parekh</span>
            </h1>
            <h2 className="text-2xl md:text-3xl font-serif text-gray-brown mb-6">
              Founder & CEO of MaidThis Franchise
            </h2>
            <p className="text-lg md:text-xl text-gray-brown mb-8 leading-relaxed">
              I build location-independent businesses and help entrepreneurs achieve freedom.
              After traveling to 60+ countries and building MaidThis into a 7-figure
              company, I'm now sharing the blueprint through franchising and coaching.
            </p>

            {/* Social Links */}
            <div className="flex items-center space-x-6 mb-8">
              <a
                href="https://twitter.com/NeelBParekh"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-brown hover:text-primary transition-colors"
                aria-label="Twitter"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/in/neelparekh/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-brown hover:text-primary transition-colors"
                aria-label="LinkedIn"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              <Link
                to="about"
                smooth={true}
                duration={500}
                offset={-80}
                className="btn-primary cursor-pointer"
              >
                Learn More
              </Link>
              <a
                href="https://maidthisfranchise.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
              >
                Explore Franchise
              </a>
            </div>
          </div>

          {/* Profile Image Placeholder */}
          <div className="order-1 md:order-2">
            <div className="relative">
              <div className="aspect-square rounded-3xl bg-gradient-to-br from-primary via-secondary to-accent p-1">
                <div className="w-full h-full rounded-3xl overflow-hidden">
                  <img
                    src="/images/profile.jpg"
                    alt="Neel Parekh"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              {/* Decorative Elements */}
              <div className="absolute -z-10 top-8 -right-8 w-32 h-32 bg-tertiary rounded-full blur-3xl opacity-50"></div>
              <div className="absolute -z-10 -bottom-8 -left-8 w-40 h-40 bg-accent rounded-full blur-3xl opacity-50"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
